import React from 'react';
import { Select, OptionType } from '../Input';

const PROVINCES = [
  {
    name: 'Agrigento',
    province: 'AG',
    region: 'Sicilia',
  },
  {
    name: 'Alessandria',
    province: 'AL',
    region: 'Piemonte',
  },
  {
    name: 'Ancona',
    province: 'AN',
    region: 'Marche',
  },
  {
    name: 'Arezzo',
    province: 'AR',
    region: 'Toscana',
  },
  {
    name: 'Ascoli Piceno',
    province: 'AP',
    region: 'Marche',
  },
  {
    name: 'Asti',
    province: 'AT',
    region: 'Piemonte',
  },
  {
    name: 'Avellino',
    province: 'AV',
    region: 'Campania',
  },
  {
    name: 'Bari',
    province: 'BA',
    region: 'Puglia',
  },
  {
    name: 'Barletta-Andria-Trani',
    province: 'BT',
    region: 'Puglia',
  },
  {
    name: 'Belluno',
    province: 'BL',
    region: 'Veneto',
  },
  {
    name: 'Benevento',
    province: 'BN',
    region: 'Campania',
  },
  {
    name: 'Bergamo',
    province: 'BG',
    region: 'Lombardia',
  },
  {
    name: 'Biella',
    province: 'BI',
    region: 'Piemonte',
  },
  {
    name: 'Bologna',
    province: 'BO',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Bolzano/Bozen',
    province: 'BZ',
    region: 'Trentino-Alto Adige/Südtirol',
  },
  {
    name: 'Brescia',
    province: 'BS',
    region: 'Lombardia',
  },
  {
    name: 'Brindisi',
    province: 'BR',
    region: 'Puglia',
  },
  {
    name: 'Cagliari',
    province: 'CA',
    region: 'Sardegna',
  },
  {
    name: 'Caltanissetta',
    province: 'CL',
    region: 'Sicilia',
  },
  {
    name: 'Campobasso',
    province: 'CB',
    region: 'Molise',
  },
  {
    name: 'Carbonia-Iglesias',
    province: 'CI',
    region: 'Sardegna',
  },
  {
    name: 'Caserta',
    province: 'CE',
    region: 'Campania',
  },
  {
    name: 'Catania',
    province: 'CT',
    region: 'Sicilia',
  },
  {
    name: 'Catanzaro',
    province: 'CZ',
    region: 'Calabria',
  },
  {
    name: 'Chieti',
    province: 'CH',
    region: 'Abruzzo',
  },
  {
    name: 'Como',
    province: 'CO',
    region: 'Lombardia',
  },
  {
    name: 'Cosenza',
    province: 'CS',
    region: 'Calabria',
  },
  {
    name: 'Cremona',
    province: 'CR',
    region: 'Lombardia',
  },
  {
    name: 'Crotone',
    province: 'KR',
    region: 'Calabria',
  },
  {
    name: 'Cuneo',
    province: 'CN',
    region: 'Piemonte',
  },
  {
    name: 'Enna',
    province: 'EN',
    region: 'Sicilia',
  },
  {
    name: 'Fermo',
    province: 'FM',
    region: 'Marche',
  },
  {
    name: 'Ferrara',
    province: 'FE',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Firenze',
    province: 'FI',
    region: 'Toscana',
  },
  {
    name: 'Foggia',
    province: 'FG',
    region: 'Puglia',
  },
  {
    name: 'Forlì-Cesena',
    province: 'FC',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Frosinone',
    province: 'FR',
    region: 'Lazio',
  },
  {
    name: 'Genova',
    province: 'GE',
    region: 'Liguria',
  },
  {
    name: 'Gorizia',
    province: 'GO',
    region: 'Friuli-Venezia Giulia',
  },
  {
    name: 'Grosseto',
    province: 'GR',
    region: 'Toscana',
  },
  {
    name: 'Imperia',
    province: 'IM',
    region: 'Liguria',
  },
  {
    name: 'Isernia',
    province: 'IS',
    region: 'Molise',
  },
  {
    name: "L'Aquila",
    province: 'AQ',
    region: 'Abruzzo',
  },
  {
    name: 'La Spezia',
    province: 'SP',
    region: 'Liguria',
  },
  {
    name: 'Latina',
    province: 'LT',
    region: 'Lazio',
  },
  {
    name: 'Lecce',
    province: 'LE',
    region: 'Puglia',
  },
  {
    name: 'Lecco',
    province: 'LC',
    region: 'Lombardia',
  },
  {
    name: 'Livorno',
    province: 'LI',
    region: 'Toscana',
  },
  {
    name: 'Lodi',
    province: 'LO',
    region: 'Lombardia',
  },
  {
    name: 'Lucca',
    province: 'LU',
    region: 'Toscana',
  },
  {
    name: 'Macerata',
    province: 'MC',
    region: 'Marche',
  },
  {
    name: 'Mantova',
    province: 'MN',
    region: 'Lombardia',
  },
  {
    name: 'Massa-Carrara',
    province: 'MS',
    region: 'Toscana',
  },
  {
    name: 'Matera',
    province: 'MT',
    region: 'Basilicata',
  },
  {
    name: 'Medio Campidano',
    province: 'VS',
    region: 'Sardegna',
  },
  {
    name: 'Messina',
    province: 'ME',
    region: 'Sicilia',
  },
  {
    name: 'Milano',
    province: 'MI',
    region: 'Lombardia',
  },
  {
    name: 'Modena',
    province: 'MO',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Monza e della Brianza',
    province: 'MB',
    region: 'Lombardia',
  },
  {
    name: 'Napoli',
    province: 'NA',
    region: 'Campania',
  },
  {
    name: 'Novara',
    province: 'NO',
    region: 'Piemonte',
  },
  {
    name: 'Nuoro',
    province: 'NU',
    region: 'Sardegna',
  },
  {
    name: 'Ogliastra',
    province: 'OG',
    region: 'Sardegna',
  },
  {
    name: 'Olbia-Tempio',
    province: 'OT',
    region: 'Sardegna',
  },
  {
    name: 'Oristano',
    province: 'OR',
    region: 'Sardegna',
  },
  {
    name: 'Padova',
    province: 'PD',
    region: 'Veneto',
  },
  {
    name: 'Palermo',
    province: 'PA',
    region: 'Sicilia',
  },
  {
    name: 'Parma',
    province: 'PR',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Pavia',
    province: 'PV',
    region: 'Lombardia',
  },
  {
    name: 'Perugia',
    province: 'PG',
    region: 'Umbria',
  },
  {
    name: 'Pesaro e Urbino',
    province: 'PU',
    region: 'Marche',
  },
  {
    name: 'Pescara',
    province: 'PE',
    region: 'Abruzzo',
  },
  {
    name: 'Piacenza',
    province: 'PC',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Pisa',
    province: 'PI',
    region: 'Toscana',
  },
  {
    name: 'Pistoia',
    province: 'PT',
    region: 'Toscana',
  },
  {
    name: 'Pordenone',
    province: 'PN',
    region: 'Friuli-Venezia Giulia',
  },
  {
    name: 'Potenza',
    province: 'PZ',
    region: 'Basilicata',
  },
  {
    name: 'Prato',
    province: 'PO',
    region: 'Toscana',
  },
  {
    name: 'Ragusa',
    province: 'RG',
    region: 'Sicilia',
  },
  {
    name: 'Ravenna',
    province: 'RA',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Reggio di Calabria',
    province: 'RC',
    region: 'Calabria',
  },
  {
    name: "Reggio nell'Emilia",
    province: 'RE',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Rieti',
    province: 'RI',
    region: 'Lazio',
  },
  {
    name: 'Rimini',
    province: 'RN',
    region: 'Emilia-Romagna',
  },
  {
    name: 'Roma',
    province: 'RM',
    region: 'Lazio',
  },
  {
    name: 'Rovigo',
    province: 'RO',
    region: 'Veneto',
  },
  {
    name: 'Salerno',
    province: 'SA',
    region: 'Campania',
  },
  {
    name: 'Sassari',
    province: 'SS',
    region: 'Sardegna',
  },
  {
    name: 'Savona',
    province: 'SV',
    region: 'Liguria',
  },
  {
    name: 'Siena',
    province: 'SI',
    region: 'Toscana',
  },
  {
    name: 'Siracusa',
    province: 'SR',
    region: 'Sicilia',
  },
  {
    name: 'Sondrio',
    province: 'SO',
    region: 'Lombardia',
  },
  {
    name: 'Taranto',
    province: 'TA',
    region: 'Puglia',
  },
  {
    name: 'Teramo',
    province: 'TE',
    region: 'Abruzzo',
  },
  {
    name: 'Terni',
    province: 'TR',
    region: 'Umbria',
  },
  {
    name: 'Torino',
    province: 'TO',
    region: 'Piemonte',
  },
  {
    name: 'Trapani',
    province: 'TP',
    region: 'Sicilia',
  },
  {
    name: 'Trento',
    province: 'TN',
    region: 'Trentino-Alto Adige/Südtirol',
  },
  {
    name: 'Treviso',
    province: 'TV',
    region: 'Veneto',
  },
  {
    name: 'Trieste',
    province: 'TS',
    region: 'Friuli-Venezia Giulia',
  },
  {
    name: 'Udine',
    province: 'UD',
    region: 'Friuli-Venezia Giulia',
  },
  {
    name: "Valle d'Aosta/Vallée d'Aoste",
    province: 'AO',
    region: "Valle d'Aosta/Vallée d'Aoste",
  },
  {
    name: 'Varese',
    province: 'VA',
    region: 'Lombardia',
  },
  {
    name: 'Venezia',
    province: 'VE',
    region: 'Veneto',
  },
  {
    name: 'Verbano-Cusio-Ossola',
    province: 'VB',
    region: 'Piemonte',
  },
  {
    name: 'Vercelli',
    province: 'VC',
    region: 'Piemonte',
  },
  {
    name: 'Verona',
    province: 'VR',
    region: 'Veneto',
  },
  {
    name: 'Vibo Valentia',
    province: 'VV',
    region: 'Calabria',
  },
  {
    name: 'Vicenza',
    province: 'VI',
    region: 'Veneto',
  },
  {
    name: 'Viterbo',
    province: 'VT',
    region: 'Lazio',
  },
];

type ProvinceSelectorProps = {
  className?: string;
  onChange: (province: string) => any;
  value: string;
};

export const ProvinceSelector: React.FunctionComponent<
  ProvinceSelectorProps
> = ({ className, onChange, value }) => (
  <Select
    className={className}
    onChange={(value) => onChange((value as OptionType).value)}
    options={PROVINCES.map(({ name, province }) => ({
      label: name,
      value: province,
    }))}
    inputValue={value}
  />
);
